/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-import-module-exports */
import React from 'react';

const SvgComponent = ({ children, ...rest }) => React.createElement('svg', rest, children);
const createElement = (tag) => ({ children, ...rest }) => React.createElement(tag, rest, children);

const Svg = SvgComponent;
const Circle = createElement('circle');
const ClipPath = createElement('clipPath');
const Defs = createElement('defs');
const Ellipse = createElement('ellipse');
const ForeignObject = createElement('foreignObject');
const G = createElement('g');
const Image = createElement('image');
const Line = createElement('line');
const LinearGradient = createElement('linearGradient');
const Marker = createElement('marker');
const Mask = createElement('mask');
const Path = createElement('path');
const Pattern = createElement('pattern');
const Polygon = createElement('polygon');
const Polyline = createElement('polyline');
const RadialGradient = createElement('radialGradient');
const Rect = createElement('rect');
const Stop = createElement('stop');
const Symbol = createElement('symbol');
const Text = createElement('text');
const TSpan = createElement('tspan');
const Use = createElement('use');
const SvgXml = SvgComponent;

// ts-prune-ignore-next
export {
    Svg,
    Circle,
    ClipPath,
    Defs,
    Ellipse,
    ForeignObject,
    G,
    Image,
    Line,
    LinearGradient,
    Marker,
    Mask,
    Path,
    Pattern,
    Polygon,
    Polyline,
    RadialGradient,
    Rect,
    Stop,
    Symbol,
    Text,
    TSpan,
    Use,
    SvgXml,
    SvgComponent as default,
};
